import { adminApi } from "../utils/admin-api-axios";

export const getDashboardStats = async () => {
  try {
    const response = await adminApi.getDashboardStats();
    console.log(response);
    return response;
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    return { success: false, error: error.message };
  }
};
